var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 330,
    viewBox: "0 0 412 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M397.768 164.743C397.768 210.793 378.958 252.303 348.796 282.138C319.282 311.649 278.417 329.485 233.336 329.485C188.58 329.485 147.715 311.325 117.877 282.138C87.7154 252.303 68.9045 210.793 68.9045 164.743C68.9045 73.6154 142.526 0 233.336 0C324.147 0 397.768 73.9397 397.768 164.743Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7763 222.984C50.5803 222.984 56.9061 216.654 56.9061 208.856C56.9061 201.058 50.5803 194.727 42.7763 194.727C34.9751 194.727 28.6467 201.058 28.6467 208.856C28.6467 216.654 34.9751 222.984 42.7763 222.984Z",
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_d_13686_165596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.93 89.4678V240.018C359.93 246.295 354.914 251.239 348.765 251.239H121.996C115.847 251.239 110.752 246.213 110.752 240.018V89.4678C110.752 83.3001 115.768 78.2461 121.996 78.2461H348.765C354.914 78.2461 359.93 83.3001 359.93 89.4678Z",
    fill: "url(#paint0_linear_13686_165596)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M359.93 89.4678V106.313H110.752V89.4678C110.752 83.3001 115.768 78.2461 121.996 78.2461H348.765C354.914 78.2461 359.93 83.3001 359.93 89.4678Z",
    fill: "#707993"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.446 96.4769C128.769 96.4769 130.652 94.5755 130.652 92.2389C130.652 89.9022 128.769 88.0273 126.446 88.0273C124.122 88.0273 122.24 89.9022 122.24 92.2389C122.24 94.5755 124.122 96.4769 126.446 96.4769Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.199 96.4769C142.522 96.4769 144.405 94.5755 144.405 92.2389C144.405 89.9022 142.522 88.0273 140.199 88.0273C137.876 88.0273 135.992 89.9022 135.992 92.2389C135.992 94.5755 137.876 96.4769 140.199 96.4769Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.875 96.4769C156.198 96.4769 158.081 94.5755 158.081 92.2389C158.081 89.9022 156.198 88.0273 153.875 88.0273C151.551 88.0273 149.668 89.9022 149.668 92.2389C149.668 94.5755 151.551 96.4769 153.875 96.4769Z",
    fill: "#989FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.77 208.855H307.909",
    stroke: "#D5DDEA",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.669 224.395H285.018",
    stroke: "#D5DDEA",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.019 135.551C245.293 135.551 254.191 144.49 254.191 158.972C254.191 173.453 245.292 182.42 235.019 182.42C224.824 182.42 215.843 173.453 215.843 158.972C215.843 144.49 224.742 135.551 235.019 135.551ZM206.057 165.163H211.072V173.45H205.975V181.52H196.429V173.45H175.395V163.859L194.891 136.58H206.057V165.163ZM290.356 165.163H295.373V173.45H290.275V181.52H280.729V173.45H259.695V163.859L279.191 136.58H290.356V165.163ZM235.019 144.327C230.244 144.327 225.471 149.136 225.471 159.053C225.471 168.97 230.244 173.779 235.019 173.779C239.79 173.779 244.564 168.97 244.564 159.053C244.564 149.136 239.79 144.327 235.019 144.327ZM184.294 165.082H196.429V147.747L184.294 165.082ZM268.513 165.082H280.648V147.747L268.513 165.082Z",
    fill: "url(#paint1_linear_13686_165596)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M348.913 284.496L294.712 230.346L307.138 217.902L361.296 272.107L348.913 284.496Z",
    fill: "#989FB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M367.755 303.544L326.194 261.974C322.725 258.523 322.725 252.871 326.194 249.394C329.664 245.916 335.322 245.916 338.792 249.394L380.352 290.937C383.822 294.415 383.822 300.066 380.352 303.544C376.882 307.022 371.225 307.022 367.755 303.544Z",
    fill: "#858B9B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M364.798 306.203L311.325 252.731C310.083 251.481 310.083 249.471 311.325 248.194L324.993 234.527C326.237 233.277 328.251 233.277 329.536 234.527L383.009 287.998C384.251 289.221 384.251 291.232 383.009 292.536L369.341 306.203C368.053 307.426 366.04 307.426 364.798 306.203Z",
    fill: "url(#paint2_linear_13686_165596)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233.356 55.832C176.628 55.832 130.655 101.804 130.655 158.536C130.655 215.213 176.628 261.213 233.315 261.213C290.043 261.213 336.017 215.241 336.017 158.536C336.017 101.804 290.043 55.832 233.356 55.832ZM233.356 242.194C187.812 242.194 150.92 204.726 150.92 158.482C150.92 112.265 187.812 74.8241 233.356 74.8241C278.903 74.8241 315.792 112.292 315.792 158.536C315.792 204.753 278.859 242.194 233.356 242.194Z",
    fill: "url(#paint3_linear_13686_165596)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M400.541 62.6233C406.696 62.6233 411.682 57.6515 411.682 51.4839C411.682 45.3434 406.696 40.3438 400.541 40.3438C394.389 40.3438 389.401 45.3434 389.401 51.4839C389.401 57.6515 394.389 62.6233 400.541 62.6233Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M368.943 19.1505C373.146 19.1505 376.551 15.7548 376.551 11.5434C376.551 7.35914 373.146 3.93555 368.943 3.93555C364.742 3.93555 361.334 7.35914 361.334 11.5434C361.334 15.7548 364.742 19.1505 368.943 19.1505Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60829 59.4832C11.8119 59.4832 15.2166 56.0868 15.2166 51.8754C15.2166 47.6912 11.8119 44.2676 7.60829 44.2676C3.40741 44.2676 0 47.6912 0 51.8754C0 56.0868 3.40741 59.4832 7.60829 59.4832Z",
    fill: "white",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13686_165596",
    x: 88.7522,
    y: 67.2461,
    width: 293.178,
    height: 216.994,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13686_165596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13686_165596",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13686_165596",
    x1: 235.26,
    y1: 74.2521,
    x2: 235.26,
    y2: 253.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F87A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#656C82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13686_165596",
    x1: 254.628,
    y1: 135.548,
    x2: 252.058,
    y2: 192.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A98B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13686_165596",
    x1: 310.361,
    y1: 270.365,
    x2: 383.952,
    y2: 270.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13686_165596",
    x1: 190.56,
    y1: 37.3203,
    x2: 374.56,
    y2: 364.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656B80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Dark);
export default __webpack_public_path__ + "static/media/404-dark.59d2998081e9619c752d46b24bcfb973.svg";
export { ForwardRef as ReactComponent };